export default __webpack_public_path__ + "static/media/IMG_3866.3a28c90b.JPG";